import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSwitchToAnotherBusinessProfileReducer from '../reducers/switch-to-another-business-profile.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

export const getSwitchToAnotherBusinessProfileState = createSelector(
  getAuthState,
  state => state[fromSwitchToAnotherBusinessProfileReducer.switchToAnotherBusinessProfileFeatureKey]
);

export const getSwitchToAntherBusinessProfileResponse = createSelector(
  getSwitchToAnotherBusinessProfileState,
  fromSwitchToAnotherBusinessProfileReducer.switchToAntherBusinessProfileResponse
);
